import { ReactNode, FC, useRef } from 'react';
import { useHover } from 'react-use';
import cn from 'classnames';

import styles from './Tooltip.module.scss';

import './Tooltip.scss';

interface ITooltipProps {
  overlayClassName?: string;
  placement?: 'bottom' | 'right' | 'topLeft' | 'top' | 'left' | 'topRight';
  content: ReactNode;
  type?: 'info' | 'label' | 'history';
  maxWidth?: number | undefined;
}

const Tooltip: FC<ITooltipProps> = ({ overlayClassName, placement = 'right', content, children, type, maxWidth }) => {
  const iconRef = useRef<HTMLSpanElement>(null);

  const { x, y, width, height } = iconRef.current?.getBoundingClientRect() || {};

  const [hoverable, isHovered] = useHover(
    <span className={type !== 'label' ? styles.TooltipIcon : undefined} ref={iconRef}>
      {children}
    </span>,
  );

  const overlayClassNames = () => {
    switch (type) {
      case 'info':
        return cn(
          styles.TooltipInfoContainer,
          overlayClassName,
          styles[`TooltipInfoPlacement${placement.charAt(0).toUpperCase()}${placement.slice(1)}`],
        );
      case 'label':
        return cn(
          styles.TooltipLabelContainer,
          overlayClassName,
          styles[`TooltipInfoPlacement${placement.charAt(0).toUpperCase()}${placement.slice(1)}`],
        );
      case 'history':
        return cn(
          styles.TooltipHistoryContainer,
          overlayClassName,
          styles[`TooltipInfoPlacement${placement.charAt(0).toUpperCase()}${placement.slice(1)}`],
        );
      default:
        return cn(
          styles.TooltipContainer,
          overlayClassName,
          styles[`TooltipPlacement${placement.charAt(0).toUpperCase()}${placement.slice(1)}`],
        );
    }
  };

  const getTopSize = () => {
    if (y || height) {
      switch (placement) {
        case 'left':
        case 'right':
          return Number(y) + Number(height) / 2;
        case 'bottom':
          return Number(y) + Number(height) + 11;
        default:
          return y;
      }
    }
  };

  const getRightSize = () => {
    if (x || width) {
      switch (placement) {
        case 'right':
          return Number(x) + Number(width) + 11;
        case 'bottom':
          return Number(x) + Number(width) / 2;
        default:
          return x;
      }
    }
  };

  return (
    <div className={cn(styles.Tooltip, { [styles.Relative]: type !== 'label' })}>
      {hoverable}
      {content && isHovered && (
        <div
          className={overlayClassNames()}
          style={{
            top: getTopSize(),
            left: getRightSize(),
            width: maxWidth,
          }}
        >
          {content}
        </div>
      )}
    </div>
  );
};

export { Tooltip };
